import { Grid } from "@mui/material";
import React from "react";
import NewsHeader from "../componets/NewsHeader";
import Header from "../componets/Header";
import BannerPage from "../componets/BannerPage";
import Facility from "../componets/Facility";
import InfoPage from "../componets/InfoPage";
import AboutUs from "../componets/AboutUs";
import Courses from "../componets/Courses";
import Acheivements from "../componets/Acheivements";
import ExperiancedStaff from "../componets/ExperiancedStaff";
import Review from "../componets/Review";
import Footer from "../componets/Footer";
import Gallary from "../layouts/Gallary";
import Contact from "./Contact";
import SumerCamp from "../componets/SumerCamp";
import Facilities from "../componets/Facilities";

const HomePage = () => {
  return (
    <Grid>
      <NewsHeader />
      <Header />
      <BannerPage />
      {/* <Facility /> */}
      <InfoPage />
      <SumerCamp />
      <Courses />
      <AboutUs />
      <Acheivements />
      <Facilities />
      {/* <ExperiancedStaff /> */}
      {/* <Review/> */}
      <Gallary />
      <Contact />
      <Footer />
    </Grid>
  );
};

export default HomePage;
